module.exports = {
    switchTabs: function () {
        $('.tab-links a').on('click', function (e) {
            e.preventDefault();

            var currentAttrValue = $(this).attr('href');
            $('.tab' + currentAttrValue)
                .addClass('active')
                .siblings()
                .removeClass('active');

            // Change/Remove active class in the tab links
            $(this)
                .parent('li')
                .addClass('active')
                .siblings()
                .removeClass('active');
        });
    },
    initTabs: function () {
        $('.tab-links li:first-child').addClass('active');
        $('.tab-content .tab:first-child').addClass('active');
    }
};
